/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Event_ClassInputs */

const en_verify_event_class = /** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event / Class`)
};

const es_verify_event_class = /** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento / Clase`)
};

const fr_verify_event_class = /** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement / Classe`)
};

const de_verify_event_class = /** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event / Klasse`)
};

const id_verify_event_class = /** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara / Kelas`)
};

/** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */
const ja_verify_event_class = en_verify_event_class;

/** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */
const zh_verify_event_class = en_verify_event_class;

/** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */
const ar_verify_event_class = en_verify_event_class;

/** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */
const it_verify_event_class = en_verify_event_class;

/** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */
const ru_verify_event_class = en_verify_event_class;

/** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */
const pt_verify_event_class = en_verify_event_class;

/** @type {(inputs: Verify_Event_ClassInputs) => LocalizedString} */
const ko_verify_event_class = en_verify_event_class;

/**
* | output |
* | --- |
* | "Event / Class" |
*
* @param {Verify_Event_ClassInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_event_class = /** @type {((inputs?: Verify_Event_ClassInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Event_ClassInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_event_class(inputs)
	if (locale === "es") return es_verify_event_class(inputs)
	if (locale === "fr") return fr_verify_event_class(inputs)
	if (locale === "de") return de_verify_event_class(inputs)
	if (locale === "ja") return ja_verify_event_class(inputs)
	if (locale === "zh") return zh_verify_event_class(inputs)
	if (locale === "ar") return ar_verify_event_class(inputs)
	if (locale === "id") return id_verify_event_class(inputs)
	if (locale === "it") return it_verify_event_class(inputs)
	if (locale === "ru") return ru_verify_event_class(inputs)
	if (locale === "pt") return pt_verify_event_class(inputs)
	return ko_verify_event_class(inputs)
});